import { render } from "./multiquoteLoader.vue?vue&type=template&id=b1f3ab56&scoped=true&lang=true"
import script from "./multiquoteLoader.vue?vue&type=script&lang=js"
export * from "./multiquoteLoader.vue?vue&type=script&lang=js"

import "./multiquoteLoader.vue?vue&type=style&index=0&id=b1f3ab56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f3ab56"]])

export default __exports__